import React from 'react';
import Button from 'components/Button';

import Container from 'components/Container';
import styles from './styles.module.scss';

const museumsLink = 'https://www.culture.ru/museums/institutes/location-russia';

const CatalogRedirectSection = () => {
	const redirectToMuseumsCatalog = () => window.open(museumsLink, '_blank');

	return (
		<Container>
			<div className={styles.CatalogRedirectSection}>
				<div className={styles.CatalogRedirectSection_Text}>
					Узнайте интересные факты о крупнейших музеях страны в Каталоге музеев
					на портале{' '}
					<a
						href={museumsLink}
						target="_blank"
						className={styles.CatalogRedirectSection_Link}
					>
						«Культура.РФ»
					</a>
					.
				</div>
				<Button
					width="limited"
					title="Перейти в каталог"
					onClick={redirectToMuseumsCatalog}
				/>
			</div>
		</Container>
	);
};

export default CatalogRedirectSection;
